import React, { Component } from 'react'
import { Icon, ToolTip } from '@driftt/tide-core-legacy'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as TrackingActions from 'app/modules/tracking/actions'
import { capitalize } from 'humanize-plus'
import HelpFlyout from './Popover'
import './style.styl'

class Help extends Component {
  constructor(props) {
    super(props)

    this.state = {
      flyoutOpen: false,
    }
    this.onClickOutside = this.toggleOpen
  }

  renderFlyOut() {
    if (!this.state.flyoutOpen) return null
    this.trackHelpFlyoutInteraction({ eventType: 'triggered' })
    return (
      <HelpFlyout
      trackHelpFlyout= {this.trackHelpFlyoutInteraction}
      onClickOutside={this.toggleOpen}
      />
    )
  }

  toggleOpen = () => {
    if (this.state.flyoutOpen) {
      this.trackHelpFlyoutInteraction({ eventType: 'dismissed' })
    }
    this.setState(prevState => {
      return {
        flyoutOpen: !prevState.flyoutOpen
      }
    })
  }

  renderHoverTooltip () {
    return (
    <ToolTip component={'Need Help?'} flow="right" hover={!this.state.flyoutOpen}>
      <div className="nav-status-icon-wrapper">
        <Icon width={19} name="question" />
      </div>
    </ToolTip>
    )
  }

  trackHelpFlyoutInteraction = ({ eventType, ctaInfo = {}}) => {
    // Tracking flyoutTriggered(by icon click), flyoutShown, flyoutClosed, flyoutLinkClicked
    return this.props.actions.track(`Flyout ${capitalize(eventType)}`, { subject: 'integrated-help-tooltip', ...{ ctaInfo }})
  }

  render() {
    return (
      <div className="help-wrapper">
        <div className="help-tooltip" onClick={this.toggleOpen}>
        {this.renderHoverTooltip()}
      </div>
        {this.renderFlyOut()}
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    track: TrackingActions.track
  }, dispatch),
})

export default connect(null, mapDispatchToProps)(Help)



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/Help/index.js